import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SeImageConfig } from './se-image-config.class';
import { IScreenElement } from './../screen-element.interface';
import { ScreenElementClass } from './../screen-element.class';
import { Subject } from 'rxjs/Subject';
import { Component, HostBinding, Injector, Input, OnInit, Output, ViewChild, HostListener, ElementRef, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';

// element specific config entries
@Component({
  selector: 'app-se-image',
  templateUrl: './se-image.component.html',
  styleUrls: ['./se-image.component.css']
})
export class SeImageComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {
  public elementConfig = new SeImageConfig();
  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public renderer: Renderer2
  ) {
    super(sanitizer); // initilize base class
    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected

    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }
  }

  async ngOnInit() {

  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
  }

  async ngAfterViewInit() {
    this.onElementReadySubject.next(this);
  }

  getCustomProperties() {
    const props = [
      {
        prop: {
          name: 'Image',
          controlComponent: 'imagepicker',
          propPath: 'elementConfig.imageURL'
        }
      }
    ];
    return props;
  }



}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-image/se-image.component.ts